<template>
    <v-container fill-height justify-center>
      <Reset />
    </v-container>
</template>

<script>
// @ is an alias to /src
import Reset from "@/components/components-base/login/Reset";

export default {
  name: "ResetPassword",
  created() {},
  components: {
    Reset,
  },
};
</script>
